import { computed } from "vue";
import { useStore } from "vuex";
import type { User } from "@/store/modules/AuthModule";

/**
 * Resolves company unit fields for PDF headers from the authenticated user.
 */
export function useAuthPdfDonVi() {
  const store = useStore();

  const authUser = computed(
    () => (store.getters.currentUser as User | undefined) ?? null
  );

  const tenDonVi = computed(() => authUser.value?.departmentName ?? "");

  const tenDonViCha = computed(
    () => authUser.value?.departmentParentName ?? ""
  );

  const capDonVi = computed(() => authUser.value?.capDonVi ?? null);

  return {
    tenDonVi,
    tenDonViCha,
    capDonVi,
  };
}
